"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = ({
  className
}) => {
  return _react.default.createElement(_SvgIcon.default, {
    className: className
  }, _react.default.createElement("path", {
    d: "M1.29938 17.977C0.505839 19.3102 1.46651 21 3.01797 21H20.982C22.5335 21 23.4942 19.3102 22.7006 17.977L13.7186 2.88722C12.9432 1.58451 11.0568 1.58451 10.2814 2.88722L1.29938 17.977Z",
    fill: "#F2C94C"
  }), _react.default.createElement("path", {
    d: "M14.812 15.72C14.812 14.856 14.308 13.98 13.42 13.68C14.104 13.392 14.644 12.576 14.644 11.796C14.644 11.076 14.392 10.548 13.972 10.164C13.528 9.744 12.856 9.492 12.16 9.492C11.44 9.492 10.804 9.708 10.336 10.092C9.84405 10.5 9.54405 11.1 9.53205 11.928H10.576C10.588 11.424 10.756 11.016 11.08 10.752C11.332 10.548 11.68 10.416 12.136 10.416C12.592 10.416 12.964 10.596 13.192 10.824C13.456 11.076 13.588 11.412 13.588 11.796C13.588 12.672 12.976 13.2 12.016 13.2H11.476V14.148H12.016C13.036 14.148 13.768 14.676 13.768 15.696C13.768 16.152 13.6 16.5 13.372 16.752C13.084 17.076 12.628 17.232 12.124 17.232C11.596 17.232 11.2 17.04 10.948 16.764C10.672 16.476 10.54 16.08 10.516 15.612H9.47205C9.48405 16.38 9.74805 16.968 10.18 17.4C10.648 17.868 11.32 18.156 12.124 18.156C13.06 18.156 13.732 17.868 14.176 17.4C14.584 16.968 14.812 16.368 14.812 15.72Z",
    fill: "white"
  }));
};

exports.default = _default;
module.exports = exports.default;